import { apiConnector } from "../apiconnector";
import { homeBannerEndpoints } from "../apis";

const authHeader = (token) => ({ Authorization: `Bearer ${token}` });

export const getActiveHomeBanners = async () => {
  try {
    const response = await apiConnector("GET", homeBannerEndpoints.GET_ACTIVE);
    return response?.data?.banners || [];
  } catch { return []; }
};

export const getAllHomeBanners = async (token) => {
  const response = await apiConnector("GET", homeBannerEndpoints.GET_ALL, null, authHeader(token));
  return response?.data?.banners || [];
};

export const createHomeBanner = (data, token) => apiConnector("POST", homeBannerEndpoints.CREATE, data, authHeader(token));
export const updateHomeBanner = (id, data, token) => apiConnector("PATCH", `${homeBannerEndpoints.UPDATE}/${id}`, data, authHeader(token));
export const deleteHomeBanner = (id, token) => apiConnector("DELETE", `${homeBannerEndpoints.DELETE}/${id}`, null, authHeader(token));
